import { Layout, Skeleton } from "../../components/ui";
import { useDeleteChild, useGetChildById } from "../../query/childQuery";
import { useNavigate, useParams } from "react-router-dom";
import swal from "../../utils/swal";
import ChildProfile from "./ChildProfile";

function ChildDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isLoading, data: child } = useGetChildById(id);
  const { mutate: deleteChild } = useDeleteChild();

  const handleDelete = () => {
    swal({
      title: "Are you sure?",
      text: "Do you want to delete this student?",
      icon: "warning",
      buttons: ["No, cancel it!", "Yes, I am sure!"],
      dangerMode: true,
    }).then((isConfirm) => {
      if (!isConfirm) return;
      deleteChild(id, {
        onSuccess: () => {
          swal("Success", "Student deleted successfully", "success");
          navigate("/children");
        },
        onError: (error) => {
          swal("Cannot delete", error?.message || "Failed to delete student", "error");
        },
      });
    });
  };

  return (
    <Layout className="configuration">
      <div
        className="boxDetails"
        style={{ background: "transparent", padding: 0, boxShadow: "none" }}
      >
        {isLoading && (
          <div style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
            <Skeleton active paragraph={{ rows: 10 }} />
          </div>
        )}

        {!isLoading && child && <ChildProfile child={child} onDelete={handleDelete} />}
      </div>
    </Layout>
  );
}

export default ChildDetails;
